import apiClient from './client';

export const fetchOsint = async (caseNumber) => {
  const { data } = await apiClient.get(`/api/cases/${caseNumber}/osint`);
  return data; // { sources: [...], total }
};

export const fetchDepositTrace = async (caseNumber) => {
  const { data } = await apiClient.get(`/api/cases/${caseNumber}/deposit-trace`);
  return data; // { hops: [...], deposit_amount, origin_entity, destination_entity, ... }
};

export const fetchCaseNetwork = async (caseNumber) => {
  const { data } = await apiClient.get(`/api/cases/${caseNumber}/network`);
  return data; // { elements: { nodes, edges }, prime_suspect_id, legend, source }
};
